import Role from './Role';
import User from './User';
import System from './System';
import Client from './Client';

import {
  // ROLE_MODULE,
  USER_MODULE,
  CLIENT_MODULE,
  DASHBOARD_MODULE,
  NOTIFICATION,
  PARKING_METER_MODULE,
  ROLE_MODULE,
  SYSTEM_MODULE,
  CAMERA_MODULE,
} from '../configs/moduleNames';
import Dashboard from './Dashboard';
import ParkingMeter from './ParkingMeter';
import Camera from './Camera';
import Notifications from './Notifications';

const modules = {
  [ROLE_MODULE]: Role,
  [USER_MODULE]: User,
  [SYSTEM_MODULE]: System,
  [CLIENT_MODULE]: Client,
  [DASHBOARD_MODULE]: Dashboard,
  [PARKING_METER_MODULE]: ParkingMeter,
  [NOTIFICATION]: Notifications,
  [CAMERA_MODULE]: Camera,
};

export default modules;
